import { Logo } from "./shared";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-slate-950 text-slate-400 border-t border-slate-800">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-8">
        <div>
          <Logo dark />
          <p className="text-xs text-slate-500 mt-3 max-w-sm leading-relaxed">
            Forensic account health monitoring for Amazon sellers. Official Amazon Software Partner ·
            Read-Only SP-API · 256-bit SSL.
          </p>
        </div>
        <div className="flex gap-6 text-xs font-medium">
          <a
            data-testid="footer-privacy-link"
            href="https://section3.ai/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition-colors duration-200"
          >
            Privacy Policy
          </a>
          <a
            data-testid="footer-terms-link"
            href="https://section3.ai/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition-colors duration-200"
          >
            Terms of Service
          </a>
          <span>© 2026 Protego AI</span>
        </div>
      </div>
      <p className="text-[10px] text-slate-600 mt-8 pt-6 border-t border-slate-800/80 leading-relaxed">
        Amazon, Amazon Seller Central, and all related trademarks are the property of Amazon.com, Inc. or
        its affiliates. Protego AI is an independent Amazon Software Partner and is not affiliated with or
        endorsed by Amazon.com, Inc. beyond the official Software Partner program.
      </p>
    </div>
  </footer>
);
